export function getSiteTypeFromId(id: number) {
	if (id === 1) {
		return 'sysco';
	}
	if (id === 2) {
		return 'dssi';
	}
	if (id === 3) {
		return 'dssi';
	} // automation works like DSSI
	throw new Error('unknown site type id');
}
